export function loadGooglePlaces(callback: () => void) {
    if (typeof window.google === 'undefined' || !window.google.maps || !window.google.maps.places) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_GOOGLE_MAPS_API_KEY}&libraries=places`;
        script.async = true;
        script.onload = () => callback();
        document.head.appendChild(script);
    } else {
        callback();
    }
}